import axios, { AxiosRequestConfig } from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  ICreateLabelPayload,
  ICreateProjectLabelsPayload,
  IDeleteProjectLabelsPayload,
  IFetchLabelsPayload,
  IRenameLabelPayload,
  IDeleteLabelPayload,
} from './types'

const config: AxiosRequestConfig = {
  responseType: 'json'
}

export function fetchLabels(payload: IFetchLabelsPayload) {
  return axios.get(`/api/v1/labels/`, { params: convertToSnakeCase(payload) })
}

export function createLabel(payload: ICreateLabelPayload) {
  return axios.post(`/api/v1/labels/`, convertToSnakeCase(payload), config)
}

export function createProjectLabels(payload: ICreateProjectLabelsPayload) {
  return axios.post(`/api/v1/project_labels/`, convertToSnakeCase(payload), config)
}

export function deleteProjectLabels(payload: IDeleteProjectLabelsPayload) {
  return axios.delete(`/api/v1/project_labels/`, { ...config, data: convertToSnakeCase(payload) })
}

export function renameLabel(payload: IRenameLabelPayload) {
  const { labelId, caption } = payload

  return axios.put(`/api/v1/labels/${labelId}`,  { ...config, data: convertToSnakeCase({ caption }) })
}

export function deleteLabel(payload: IDeleteLabelPayload) {
  const { labelId } = payload

  return axios.delete(`/api/v1/labels/${labelId}`,  { ...config })
}
